// extracted by mini-css-extract-plugin
export var container = "_ru-0";
export var table = "_ru-2";
export var tableWrapper = "_ru-1";